import { useState } from 'react';

export default function Contact() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      Object.entries(contactForm).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d48q0po4bso62du6dqlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
      });

      if (response.ok) {
        setSubmitStatus('Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.');
        setContactForm({ name: '', email: '', company: '', phone: '', message: '' });
      } else {
        setSubmitStatus('Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.');
      }
    } catch (error) {
      setSubmitStatus('Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.');
    }
    
    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Jetzt <span className="text-teal-400">Starten</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Kontaktieren Sie uns, für einen unverbindlichen Austausch.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-800/80 backdrop-blur-sm p-8 rounded-xl border border-gray-700">
            <form id="contact-form" data-readdy-form onSubmit={handleContactSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Vollständiger Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={contactForm.name}
                    onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-teal-500 text-sm"
                    placeholder="Geben Sie Ihren vollständigen Namen ein"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    E-Mail-Adresse *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={contactForm.email}
                    onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-teal-500 text-sm"
                    placeholder="Geben Sie Ihre E-Mail ein"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Firmenname
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={contactForm.company}
                    onChange={(e) => setContactForm({...contactForm, company: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-teal-500 text-sm"
                    placeholder="Geben Sie Ihren Firmennamen ein"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Telefonnummer
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={contactForm.phone}
                    onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-teal-500 text-sm"
                    placeholder="Geben Sie Ihre Telefonnummer ein"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Nachricht *
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={5000}
                  value={contactForm.message}
                  onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-teal-500 text-sm resize-none"
                  placeholder="Erzählen Sie uns von Ihrem Projekt und Ihren Zielen..."
                ></textarea>
                <div className="text-right text-xs text-gray-400 mt-1">
                  {contactForm.message.length}/5000 Zeichen
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 disabled:from-gray-600 disabled:to-gray-700 text-white py-4 rounded-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
              </button>
            </form>

            {submitStatus && (
              <div className="mt-6 p-4 bg-teal-600/20 border border-teal-500/50 rounded-lg">
                <p className="text-teal-400 text-center">{submitStatus}</p>
              </div>
            )}
          </div>

          <div className="mt-12 grid md:grid-cols-2 gap-8 text-center">
            <div className="bg-gray-800/50 p-6 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mx-auto mb-4">
                <i className="ri-mail-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">E-Mail an uns</h3>
              <p className="text-gray-400">Bleckmann.business@gmail.com</p>
            </div>
            
            <div className="bg-gray-800/50 p-6 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mx-auto mb-4">
                <i className="ri-time-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Antwortzeit</h3>
              <p className="text-gray-400">&lt; 24 Stunden</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
